import { render, staticRenderFns } from "./Audiences.vue?vue&type=template&id=20ebc9ca"
import script from "./Audiences.vue?vue&type=script&lang=js"
export * from "./Audiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports